module.exports = __webpack_public_path__ + "assets/img/Type E (72).4c6786a6.jpg";